<template>
  <div id="divLanguage" class="language-switcher" @click.stop="toggleDropdown">
    <!-- Botão principal -->
    <div class="flag-button">
      <img :src="currentFlag" class="flag-icon" />
    </div>

    <!-- Dropdown -->
    <transition name="fade">
      <div v-if="open" class="dropdown">
        <div
          class="dropdown-item"
          v-for="lang in languages"
          :key="lang.value"
          @click="changeLanguage(lang.value)"
        >
          <img :src="lang.avatar" class="flag-icon-small" />
          <span>{{ $t(lang.title) }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import flagBr from "@/assets/bandeiras/icon-flag-pt.svg";
import flagEs from "@/assets/bandeiras/icon-flag-es.svg";
import flagEn from "@/assets/bandeiras/icon-flag-en.svg";
import flagFr from "@/assets/bandeiras/icon-flag-fr.svg";
import flagGe from "@/assets/bandeiras/icon-flag-ge.svg";
import flagHo from "@/assets/bandeiras/icon-flag-ho.svg";
// import flagRo from "@/assets/images/flag/icon-flag-ro.svg";
// import flagZh from "@/assets/images/flag/icon-flag-zh.svg";

export default {
  data() {
    return {
      open: false,
      languages: [
        { title: "Portugues", value: "pt", avatar: flagBr },
        { title: "Espanhol", value: "es", avatar: flagEs },
        { title: "Ingles", value: "en", avatar: flagEn },
        { title: "Frances", value: "fr", avatar: flagFr },
        { title: "Alemao", value: "ge", avatar: flagGe },
        { title: "Holandes", value: "ho", avatar: flagHo }
      ]
    };
  },

  computed: {
    currentFlag() {
      const lang = this.languages.find(l => l.value === this.$i18n.locale);
      return lang ? lang.avatar : this.languages[0].avatar;
    }
  },

  mounted() {
    // Fecha dropdown se clicar fora
    document.addEventListener("click", this.closeOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeOutside);
  },

  methods: {
    toggleDropdown() {
      this.open = !this.open;
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.open = false;

      const idiomaSelecionado = {
        lang: lang
      }
      localStorage.lang = JSON.stringify(idiomaSelecionado)

      const div = document.getElementById('divLanguage')

      window.location.reload()
      div.click()
    //   window.location.reload()
    },
    closeOutside() {
      this.open = false;
    }
  }
};
</script>

<style scoped>
.language-switcher {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.flag-button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flag-icon {
  width: 28px;
  height: 28px;
  object-fit: cover;
}

.dropdown {
  position: absolute;
  top: 40px;
  right: -115px;
  background: white;
  border-radius: 8px;
  padding: 8px;
  width: 150px;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.15);
  z-index: 10;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background: #f2f2f2;
}

.flag-icon-small {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

/* Transição fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
